import * as React from 'react';

import Comment from './Comment';

import CommentInterface from '../../interfaces/Comment';

interface Props {
  comments?: CommentInterface[];
}

const CommentList = (props: Props) => {
  return(
    <div>
      {
        props.comments ?
          props.comments.map((comment, key) => {
            return (<Comment
              key={key}
              dateAdd={comment.submit_date}
              author={comment.user_name}
              comment={comment.comment} />);
          }) :
          null
      }
    </div>
  );
};

export default CommentList;
